const wait = time => new Promise(resolve => setTimeout(resolve, time))

export {
	wait
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_menu/utils.js